import { render } from "./DatasetList.vue?vue&type=template&id=178069ca&scoped=true"
import script from "./DatasetList.vue?vue&type=script&lang=js"
export * from "./DatasetList.vue?vue&type=script&lang=js"

import "./DatasetList.vue?vue&type=style&index=0&id=178069ca&lang=sass&scoped=true"

import exportComponent from "C:\\yb\\work\\website\\yunyu2021\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-178069ca"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
